import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public view : any = {
    version: 1,
    year: 2024
  }

  constructor(private _tfmService: TFMService) {
    this.view.year = new Date().getFullYear();
    this.view.version = this._tfmService.view.version;
  }
}
